import { render, staticRenderFns } from "./ComprasDiretasMeuInteresseCarrosselCard.vue?vue&type=template&id=47fa06c2&scoped=true"
import script from "./ComprasDiretasMeuInteresseCarrosselCard.vue?vue&type=script&lang=js"
export * from "./ComprasDiretasMeuInteresseCarrosselCard.vue?vue&type=script&lang=js"
import style0 from "./ComprasDiretasMeuInteresseCarrosselCard.vue?vue&type=style&index=0&id=47fa06c2&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fa06c2",
  null
  
)

export default component.exports